// tslint:disable
/**
 * Swagger for Proff
 * Swagger for Proff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CoverLetter
 */
export interface CoverLetter {
    /**
     * 
     * @type {number}
     * @memberof CoverLetter
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CoverLetter
     */
    user_id: number;
    /**
     * 
     * @type {string}
     * @memberof CoverLetter
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CoverLetter
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof CoverLetter
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CoverLetter
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CoverLetterResponse
 */
export interface CoverLetterResponse {
    /**
     * 
     * @type {string}
     * @memberof CoverLetterResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CoverLetterResponse
     */
    type: string;
    /**
     * 
     * @type {CoverLetter}
     * @memberof CoverLetterResponse
     */
    attributes: CoverLetter;
}
/**
 * 
 * @export
 * @interface CreateAccountWithCvRequest
 */
export interface CreateAccountWithCvRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWithCvRequest
     */
    user_email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWithCvRequest
     */
    user_password?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWithCvRequest
     */
    user_password_confirmation?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateAccountWithCvRequest
     */
    user_entry_policy?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWithCvRequest
     */
    profile_full_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWithCvRequest
     */
    profile_birthday_year?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWithCvRequest
     */
    profile_birthday_month?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWithCvRequest
     */
    profile_birthday_day?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWithCvRequest
     */
    profile_sex?: CreateAccountWithCvRequestProfileSexEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWithCvRequest
     */
    profile_phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWithCvRequest
     */
    profile_location?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWithCvRequest
     */
    profile_headline?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWithCvRequest
     */
    profile_website_url?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateAccountWithCvRequest
     */
    profile_profile_image?: object;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateAccountWithCvRequestProfileSexEnum {
    NotKnown = 'not_known',
    Male = 'male',
    Female = 'female',
    NotApplicable = 'not_applicable'
}

/**
 * 
 * @export
 * @interface CreateCoverLetterRequest
 */
export interface CreateCoverLetterRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCoverLetterRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCoverLetterRequest
     */
    content?: string;
}
/**
 * 
 * @export
 * @interface CreateCvCommentRequest
 */
export interface CreateCvCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvCommentRequest
     */
    table_name?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCvCommentRequest
     */
    record_id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCvCommentRequest
     */
    body?: string;
}
/**
 * 
 * @export
 * @interface CreateCvFromCopyRequest
 */
export interface CreateCvFromCopyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvFromCopyRequest
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCvFromCopyRequest
     */
    source_id?: number;
}
/**
 * 
 * @export
 * @interface CreateCvFromExampleRequest
 */
export interface CreateCvFromExampleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvFromExampleRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvFromExampleRequest
     */
    source_type?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCvFromExampleRequest
     */
    source_id?: number;
}
/**
 * 
 * @export
 * @interface CreateCvFromSampleRequest
 */
export interface CreateCvFromSampleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvFromSampleRequest
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCvFromSampleRequest
     */
    source_id?: number;
}
/**
 * 
 * @export
 * @interface CreateCvFromScratchRequest
 */
export interface CreateCvFromScratchRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvFromScratchRequest
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface CreateCvFromTemplateRequest
 */
export interface CreateCvFromTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvFromTemplateRequest
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCvFromTemplateRequest
     */
    source_id?: number;
}
/**
 * 
 * @export
 * @interface CreateCvSectionDateItemRequest
 */
export interface CreateCvSectionDateItemRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionDateItemRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionDateItemRequest
     */
    organization?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionDateItemRequest
     */
    website_url?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionDateItemRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionDateItemRequest
     */
    start_date_year?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionDateItemRequest
     */
    start_date_month?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionDateItemRequest
     */
    start_date_day?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionDateItemRequest
     */
    end_date_year?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionDateItemRequest
     */
    end_date_month?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionDateItemRequest
     */
    end_date_day?: string;
}
/**
 * 
 * @export
 * @interface CreateCvSectionDateRequest
 */
export interface CreateCvSectionDateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionDateRequest
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface CreateCvSectionGalleryItemRequest
 */
export interface CreateCvSectionGalleryItemRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionGalleryItemRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionGalleryItemRequest
     */
    page_break?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCvSectionGalleryItemRequest
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionGalleryItemRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionGalleryItemRequest
     */
    _url?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateCvSectionGalleryItemRequest
     */
    image?: object;
}
/**
 * 
 * @export
 * @interface CreateCvSectionGalleryRequest
 */
export interface CreateCvSectionGalleryRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionGalleryRequest
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface CreateCvSectionLinkItemRequest
 */
export interface CreateCvSectionLinkItemRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionLinkItemRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionLinkItemRequest
     */
    page_break?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCvSectionLinkItemRequest
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionLinkItemRequest
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface CreateCvSectionLinkRequest
 */
export interface CreateCvSectionLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionLinkRequest
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface CreateCvSectionSkillItemRequest
 */
export interface CreateCvSectionSkillItemRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionSkillItemRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionSkillItemRequest
     */
    page_break?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCvSectionSkillItemRequest
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionSkillItemRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCvSectionSkillItemRequest
     */
    strength?: number;
}
/**
 * 
 * @export
 * @interface CreateCvSectionSkillRequest
 */
export interface CreateCvSectionSkillRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionSkillRequest
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface CreateCvSectionTextRequest
 */
export interface CreateCvSectionTextRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionTextRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCvSectionTextRequest
     */
    content?: string;
}
/**
 * 
 * @export
 * @interface CreatePhotoRequest
 */
export interface CreatePhotoRequest {
    /**
     * 
     * @type {object}
     * @memberof CreatePhotoRequest
     */
    image?: object;
}
/**
 * 
 * @export
 * @interface Cv
 */
export interface Cv {
    /**
     * 
     * @type {number}
     * @memberof Cv
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Cv
     */
    cv_design_template_id?: number;
    /**
     * 
     * @type {string}
     * @memberof Cv
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Cv
     */
    publish_type: CvPublishTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Cv
     */
    original_path?: string;
    /**
     * 
     * @type {object}
     * @memberof Cv
     */
    ogp_image?: object;
    /**
     * 
     * @type {string}
     * @memberof Cv
     */
    publish_date?: string;
    /**
     * 
     * @type {string}
     * @memberof Cv
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Cv
     */
    updated_at?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CvPublishTypeEnum {
    Open = 'open',
    OpenUnlisted = 'open_unlisted',
    OpenWithPw = 'open_with_pw',
    Secret = 'secret'
}

/**
 * 
 * @export
 * @interface CvComment
 */
export interface CvComment {
    /**
     * 
     * @type {number}
     * @memberof CvComment
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CvComment
     */
    cv_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvComment
     */
    table_name: string;
    /**
     * 
     * @type {number}
     * @memberof CvComment
     */
    record_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvComment
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof CvComment
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvComment
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvCommentResponse
 */
export interface CvCommentResponse {
    /**
     * 
     * @type {string}
     * @memberof CvCommentResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvCommentResponse
     */
    type: string;
    /**
     * 
     * @type {CvComment}
     * @memberof CvCommentResponse
     */
    attributes: CvComment;
}
/**
 * 
 * @export
 * @interface CvCvSection
 */
export interface CvCvSection {
    /**
     * 
     * @type {number}
     * @memberof CvCvSection
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvCvSection
     */
    cv_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvCvSection
     */
    cv_section_type: CvCvSectionCvSectionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CvCvSection
     */
    cv_section_id: number;
    /**
     * 
     * @type {number}
     * @memberof CvCvSection
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof CvCvSection
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvCvSection
     */
    updated_at?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CvCvSectionCvSectionTypeEnum {
    CvSectionText = 'CvSectionText',
    CvSectionDate = 'CvSectionDate',
    CvSectionSkill = 'CvSectionSkill',
    CvSectionLink = 'CvSectionLink',
    CvSectionChart = 'CvSectionChart',
    CvSectionGallery = 'CvSectionGallery'
}

/**
 * 
 * @export
 * @interface CvCvSectionResponse
 */
export interface CvCvSectionResponse {
    /**
     * 
     * @type {string}
     * @memberof CvCvSectionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvCvSectionResponse
     */
    type: string;
    /**
     * 
     * @type {CvCvSection}
     * @memberof CvCvSectionResponse
     */
    attributes: CvCvSection;
    /**
     * 
     * @type {CvCvSectionResponseLinks}
     * @memberof CvCvSectionResponse
     */
    links?: CvCvSectionResponseLinks;
}
/**
 * 
 * @export
 * @interface CvCvSectionResponseLinks
 */
export interface CvCvSectionResponseLinks {
    /**
     * 
     * @type {object}
     * @memberof CvCvSectionResponseLinks
     */
    section?: object;
    /**
     * 
     * @type {object}
     * @memberof CvCvSectionResponseLinks
     */
    section_items?: object;
}
/**
 * 
 * @export
 * @interface CvDataTemplate
 */
export interface CvDataTemplate {
    /**
     * 
     * @type {string}
     * @memberof CvDataTemplate
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CvDataTemplate
     */
    cv_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvDataTemplate
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvDataTemplate
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvDataTemplateResponse
 */
export interface CvDataTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof CvDataTemplateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvDataTemplateResponse
     */
    type: string;
    /**
     * 
     * @type {CvDataTemplate}
     * @memberof CvDataTemplateResponse
     */
    attributes: CvDataTemplate;
}
/**
 * 
 * @export
 * @interface CvDesignTemplate
 */
export interface CvDesignTemplate {
    /**
     * 
     * @type {number}
     * @memberof CvDesignTemplate
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CvDesignTemplate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CvDesignTemplate
     */
    display_name: string;
}
/**
 * 
 * @export
 * @interface CvDesignTemplateResponse
 */
export interface CvDesignTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof CvDesignTemplateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvDesignTemplateResponse
     */
    type: string;
    /**
     * 
     * @type {CvDesignTemplate}
     * @memberof CvDesignTemplateResponse
     */
    attributes: CvDesignTemplate;
}
/**
 * 
 * @export
 * @interface CvDesignTemplateSample
 */
export interface CvDesignTemplateSample {
    /**
     * 
     * @type {number}
     * @memberof CvDesignTemplateSample
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvDesignTemplateSample
     */
    cv_id: number;
    /**
     * 
     * @type {number}
     * @memberof CvDesignTemplateSample
     */
    cv_design_template_id: number;
    /**
     * 
     * @type {number}
     * @memberof CvDesignTemplateSample
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof CvDesignTemplateSample
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CvDesignTemplateSample
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CvDesignTemplateSample
     */
    slug: string;
    /**
     * 
     * @type {object}
     * @memberof CvDesignTemplateSample
     */
    thumbnail_image?: object;
    /**
     * 
     * @type {string}
     * @memberof CvDesignTemplateSample
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvDesignTemplateSample
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvDesignTemplateSampleResponse
 */
export interface CvDesignTemplateSampleResponse {
    /**
     * 
     * @type {string}
     * @memberof CvDesignTemplateSampleResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvDesignTemplateSampleResponse
     */
    type: string;
    /**
     * 
     * @type {CvDesignTemplateSample}
     * @memberof CvDesignTemplateSampleResponse
     */
    attributes: CvDesignTemplateSample;
}
/**
 * 
 * @export
 * @interface CvExample
 */
export interface CvExample {
    /**
     * 
     * @type {number}
     * @memberof CvExample
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvExample
     */
    cv_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvExample
     */
    slug?: string;
    /**
     * 
     * @type {number}
     * @memberof CvExample
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof CvExample
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CvExample
     */
    description: string;
    /**
     * 
     * @type {object}
     * @memberof CvExample
     */
    thumbnail_image?: object;
    /**
     * 
     * @type {string}
     * @memberof CvExample
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvExample
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvExample
     */
    source_type?: string;
}
/**
 * 
 * @export
 * @interface CvExampleResponse
 */
export interface CvExampleResponse {
    /**
     * 
     * @type {string}
     * @memberof CvExampleResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvExampleResponse
     */
    type: string;
    /**
     * 
     * @type {CvExample}
     * @memberof CvExampleResponse
     */
    attributes: CvExample;
}
/**
 * 
 * @export
 * @interface CvResponse
 */
export interface CvResponse {
    /**
     * 
     * @type {string}
     * @memberof CvResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvResponse
     */
    type: string;
    /**
     * 
     * @type {Cv}
     * @memberof CvResponse
     */
    attributes: Cv;
    /**
     * 
     * @type {CvResponseRelationships}
     * @memberof CvResponse
     */
    relationships?: CvResponseRelationships;
}
/**
 * 
 * @export
 * @interface CvResponseRelationships
 */
export interface CvResponseRelationships {
    /**
     * 
     * @type {CvResponseRelationshipsCvDesignTemplate}
     * @memberof CvResponseRelationships
     */
    cv_design_template?: CvResponseRelationshipsCvDesignTemplate;
}
/**
 * 
 * @export
 * @interface CvResponseRelationshipsCvDesignTemplate
 */
export interface CvResponseRelationshipsCvDesignTemplate {
    /**
     * 
     * @type {CvResponseRelationshipsCvDesignTemplateData}
     * @memberof CvResponseRelationshipsCvDesignTemplate
     */
    data?: CvResponseRelationshipsCvDesignTemplateData;
}
/**
 * 
 * @export
 * @interface CvResponseRelationshipsCvDesignTemplateData
 */
export interface CvResponseRelationshipsCvDesignTemplateData {
    /**
     * 
     * @type {string}
     * @memberof CvResponseRelationshipsCvDesignTemplateData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CvResponseRelationshipsCvDesignTemplateData
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface CvSample
 */
export interface CvSample {
    /**
     * 
     * @type {number}
     * @memberof CvSample
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSample
     */
    cv_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvSample
     */
    slug?: string;
    /**
     * 
     * @type {number}
     * @memberof CvSample
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof CvSample
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CvSample
     */
    description: string;
    /**
     * 
     * @type {object}
     * @memberof CvSample
     */
    thumbnail_image?: object;
    /**
     * 
     * @type {string}
     * @memberof CvSample
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvSample
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvSampleResponse
 */
export interface CvSampleResponse {
    /**
     * 
     * @type {string}
     * @memberof CvSampleResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvSampleResponse
     */
    type: string;
    /**
     * 
     * @type {CvSample}
     * @memberof CvSampleResponse
     */
    attributes: CvSample;
}
/**
 * 
 * @export
 * @interface CvSection
 */
export interface CvSection {
    /**
     * 
     * @type {number}
     * @memberof CvSection
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSection
     */
    cv_id: number;
}
/**
 * 
 * @export
 * @interface CvSectionDate
 */
export interface CvSectionDate {
    /**
     * 
     * @type {number}
     * @memberof CvSectionDate
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSectionDate
     */
    cv_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvSectionDate
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionDate
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvSectionDateItem
 */
export interface CvSectionDateItem {
    /**
     * 
     * @type {number}
     * @memberof CvSectionDateItem
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSectionDateItem
     */
    cv_section_date_id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSectionDateItem
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof CvSectionDateItem
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionDateItem
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvSectionDateItemResponse
 */
export interface CvSectionDateItemResponse {
    /**
     * 
     * @type {string}
     * @memberof CvSectionDateItemResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionDateItemResponse
     */
    type: string;
    /**
     * 
     * @type {CvSectionDateItem}
     * @memberof CvSectionDateItemResponse
     */
    attributes: CvSectionDateItem;
}
/**
 * 
 * @export
 * @interface CvSectionDateResponse
 */
export interface CvSectionDateResponse {
    /**
     * 
     * @type {string}
     * @memberof CvSectionDateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionDateResponse
     */
    type: string;
    /**
     * 
     * @type {CvSectionDate}
     * @memberof CvSectionDateResponse
     */
    attributes: CvSectionDate;
}
/**
 * 
 * @export
 * @interface CvSectionGallery
 */
export interface CvSectionGallery {
    /**
     * 
     * @type {number}
     * @memberof CvSectionGallery
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSectionGallery
     */
    cv_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvSectionGallery
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionGallery
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvSectionGalleryItem
 */
export interface CvSectionGalleryItem {
    /**
     * 
     * @type {number}
     * @memberof CvSectionGalleryItem
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSectionGalleryItem
     */
    cv_section_gallery_id: number;
    /**
     * 
     * @type {CvSectionGalleryItemImage}
     * @memberof CvSectionGalleryItem
     */
    image: CvSectionGalleryItemImage;
    /**
     * 
     * @type {string}
     * @memberof CvSectionGalleryItem
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionGalleryItem
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvSectionGalleryItemImage
 */
export interface CvSectionGalleryItemImage {
    /**
     * 
     * @type {object}
     * @memberof CvSectionGalleryItemImage
     */
    thumbnail?: object;
    /**
     * 
     * @type {object}
     * @memberof CvSectionGalleryItemImage
     */
    large?: object;
}
/**
 * 
 * @export
 * @interface CvSectionGalleryItemResponse
 */
export interface CvSectionGalleryItemResponse {
    /**
     * 
     * @type {string}
     * @memberof CvSectionGalleryItemResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionGalleryItemResponse
     */
    type: string;
    /**
     * 
     * @type {CvSectionGalleryItem}
     * @memberof CvSectionGalleryItemResponse
     */
    attributes: CvSectionGalleryItem;
}
/**
 * 
 * @export
 * @interface CvSectionGalleryResponse
 */
export interface CvSectionGalleryResponse {
    /**
     * 
     * @type {string}
     * @memberof CvSectionGalleryResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionGalleryResponse
     */
    type: string;
    /**
     * 
     * @type {CvSectionGallery}
     * @memberof CvSectionGalleryResponse
     */
    attributes: CvSectionGallery;
}
/**
 * 
 * @export
 * @interface CvSectionLink
 */
export interface CvSectionLink {
    /**
     * 
     * @type {number}
     * @memberof CvSectionLink
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSectionLink
     */
    cv_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvSectionLink
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionLink
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvSectionLinkItem
 */
export interface CvSectionLinkItem {
    /**
     * 
     * @type {number}
     * @memberof CvSectionLinkItem
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSectionLinkItem
     */
    cv_section_link_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvSectionLinkItem
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionLinkItem
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvSectionLinkItemResponse
 */
export interface CvSectionLinkItemResponse {
    /**
     * 
     * @type {string}
     * @memberof CvSectionLinkItemResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionLinkItemResponse
     */
    type: string;
    /**
     * 
     * @type {CvSectionLinkItem}
     * @memberof CvSectionLinkItemResponse
     */
    attributes: CvSectionLinkItem;
}
/**
 * 
 * @export
 * @interface CvSectionLinkResponse
 */
export interface CvSectionLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof CvSectionLinkResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionLinkResponse
     */
    type: string;
    /**
     * 
     * @type {CvSectionLink}
     * @memberof CvSectionLinkResponse
     */
    attributes: CvSectionLink;
}
/**
 * 
 * @export
 * @interface CvSectionProfile
 */
export interface CvSectionProfile {
    /**
     * 
     * @type {number}
     * @memberof CvSectionProfile
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSectionProfile
     */
    cv_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvSectionProfile
     */
    sex?: CvSectionProfileSexEnum;
    /**
     * 
     * @type {CvSectionProfileProfileImage}
     * @memberof CvSectionProfile
     */
    profile_image?: CvSectionProfileProfileImage;
    /**
     * 
     * @type {string}
     * @memberof CvSectionProfile
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionProfile
     */
    updated_at?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CvSectionProfileSexEnum {
    NotKnown = 'not_known',
    Male = 'male',
    Female = 'female',
    NotApplicable = 'not_applicable'
}

/**
 * 
 * @export
 * @interface CvSectionProfileProfileImage
 */
export interface CvSectionProfileProfileImage {
    /**
     * 
     * @type {object}
     * @memberof CvSectionProfileProfileImage
     */
    sm?: object;
    /**
     * 
     * @type {object}
     * @memberof CvSectionProfileProfileImage
     */
    mid?: object;
    /**
     * 
     * @type {object}
     * @memberof CvSectionProfileProfileImage
     */
    lg?: object;
}
/**
 * 
 * @export
 * @interface CvSectionProfileResponse
 */
export interface CvSectionProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof CvSectionProfileResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionProfileResponse
     */
    type: string;
    /**
     * 
     * @type {CvSectionProfile}
     * @memberof CvSectionProfileResponse
     */
    attributes: CvSectionProfile;
}
/**
 * 
 * @export
 * @interface CvSectionSkill
 */
export interface CvSectionSkill {
    /**
     * 
     * @type {number}
     * @memberof CvSectionSkill
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSectionSkill
     */
    cv_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvSectionSkill
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionSkill
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvSectionSkillItem
 */
export interface CvSectionSkillItem {
    /**
     * 
     * @type {number}
     * @memberof CvSectionSkillItem
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSectionSkillItem
     */
    cv_section_skill_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvSectionSkillItem
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionSkillItem
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvSectionSkillItemResponse
 */
export interface CvSectionSkillItemResponse {
    /**
     * 
     * @type {string}
     * @memberof CvSectionSkillItemResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionSkillItemResponse
     */
    type: string;
    /**
     * 
     * @type {CvSectionSkillItem}
     * @memberof CvSectionSkillItemResponse
     */
    attributes: CvSectionSkillItem;
}
/**
 * 
 * @export
 * @interface CvSectionSkillResponse
 */
export interface CvSectionSkillResponse {
    /**
     * 
     * @type {string}
     * @memberof CvSectionSkillResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionSkillResponse
     */
    type: string;
    /**
     * 
     * @type {CvSectionSkill}
     * @memberof CvSectionSkillResponse
     */
    attributes: CvSectionSkill;
}
/**
 * 
 * @export
 * @interface CvSectionText
 */
export interface CvSectionText {
    /**
     * 
     * @type {number}
     * @memberof CvSectionText
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CvSectionText
     */
    cv_id: number;
    /**
     * 
     * @type {string}
     * @memberof CvSectionText
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionText
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface CvSectionTextResponse
 */
export interface CvSectionTextResponse {
    /**
     * 
     * @type {string}
     * @memberof CvSectionTextResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CvSectionTextResponse
     */
    type: string;
    /**
     * 
     * @type {CvSectionText}
     * @memberof CvSectionTextResponse
     */
    attributes: CvSectionText;
}
/**
 * 
 * @export
 * @interface ErrorOutput
 */
export interface ErrorOutput {
    /**
     * 
     * @type {Array<string>}
     * @memberof ErrorOutput
     */
    errors: Array<string>;
}
/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * 
     * @type {Array<CvSampleResponse>}
     * @memberof InlineResponse200
     */
    data: Array<CvSampleResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
    /**
     * 
     * @type {Array<CvExampleResponse>}
     * @memberof InlineResponse2001
     */
    data: Array<CvExampleResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 {
    /**
     * 
     * @type {Array<CoverLetterResponse>}
     * @memberof InlineResponse20010
     */
    data: Array<CoverLetterResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20011
 */
export interface InlineResponse20011 {
    /**
     * 
     * @type {Array<CvCommentResponse>}
     * @memberof InlineResponse20011
     */
    data: Array<CvCommentResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
    /**
     * 
     * @type {Array<CvDataTemplateResponse>}
     * @memberof InlineResponse2002
     */
    data: Array<CvDataTemplateResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
    /**
     * 
     * @type {Array<CvDesignTemplateSampleResponse>}
     * @memberof InlineResponse2003
     */
    data: Array<CvDesignTemplateSampleResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
    /**
     * 
     * @type {Array<CvDesignTemplateResponse>}
     * @memberof InlineResponse2004
     */
    data: Array<CvDesignTemplateResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 {
    /**
     * 
     * @type {Array<CvCvSectionResponse>}
     * @memberof InlineResponse2005
     */
    data: Array<CvCvSectionResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
    /**
     * 
     * @type {Array<CvResponse>}
     * @memberof InlineResponse2006
     */
    data: Array<CvResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2007
 */
export interface InlineResponse2007 {
    /**
     * 
     * @type {CvResponse}
     * @memberof InlineResponse2007
     */
    data: CvResponse;
    /**
     * 
     * @type {Array<CvDesignTemplateResponse>}
     * @memberof InlineResponse2007
     */
    included?: Array<CvDesignTemplateResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2008
 */
export interface InlineResponse2008 {
    /**
     * 
     * @type {CvResponse}
     * @memberof InlineResponse2008
     */
    data: CvResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 {
    /**
     * 
     * @type {CvSectionProfileResponse}
     * @memberof InlineResponse2009
     */
    data: CvSectionProfileResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse201
 */
export interface InlineResponse201 {
    /**
     * 
     * @type {PhotoResponse}
     * @memberof InlineResponse201
     */
    data: PhotoResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2011
 */
export interface InlineResponse2011 {
    /**
     * 
     * @type {CvSectionTextResponse}
     * @memberof InlineResponse2011
     */
    data: CvSectionTextResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20110
 */
export interface InlineResponse20110 {
    /**
     * 
     * @type {CoverLetterResponse}
     * @memberof InlineResponse20110
     */
    data: CoverLetterResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20111
 */
export interface InlineResponse20111 {
    /**
     * 
     * @type {CvCommentResponse}
     * @memberof InlineResponse20111
     */
    data: CvCommentResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2012
 */
export interface InlineResponse2012 {
    /**
     * 
     * @type {CvSectionDateResponse}
     * @memberof InlineResponse2012
     */
    data: CvSectionDateResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2013
 */
export interface InlineResponse2013 {
    /**
     * 
     * @type {CvSectionDateItemResponse}
     * @memberof InlineResponse2013
     */
    data: CvSectionDateItemResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2014
 */
export interface InlineResponse2014 {
    /**
     * 
     * @type {CvSectionSkillResponse}
     * @memberof InlineResponse2014
     */
    data: CvSectionSkillResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2015
 */
export interface InlineResponse2015 {
    /**
     * 
     * @type {CvSectionSkillItemResponse}
     * @memberof InlineResponse2015
     */
    data: CvSectionSkillItemResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2016
 */
export interface InlineResponse2016 {
    /**
     * 
     * @type {CvSectionLinkResponse}
     * @memberof InlineResponse2016
     */
    data: CvSectionLinkResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2017
 */
export interface InlineResponse2017 {
    /**
     * 
     * @type {CvSectionLinkItemResponse}
     * @memberof InlineResponse2017
     */
    data: CvSectionLinkItemResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2018
 */
export interface InlineResponse2018 {
    /**
     * 
     * @type {CvSectionGalleryResponse}
     * @memberof InlineResponse2018
     */
    data: CvSectionGalleryResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2019
 */
export interface InlineResponse2019 {
    /**
     * 
     * @type {CvSectionGalleryItemResponse}
     * @memberof InlineResponse2019
     */
    data: CvSectionGalleryItemResponse;
}
/**
 * 
 * @export
 * @interface Photo
 */
export interface Photo {
    /**
     * 
     * @type {number}
     * @memberof Photo
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Photo
     */
    user_id?: number;
    /**
     * 
     * @type {object}
     * @memberof Photo
     */
    image: object;
    /**
     * 
     * @type {string}
     * @memberof Photo
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Photo
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface PhotoResponse
 */
export interface PhotoResponse {
    /**
     * 
     * @type {string}
     * @memberof PhotoResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoResponse
     */
    type: string;
    /**
     * 
     * @type {Photo}
     * @memberof PhotoResponse
     */
    attributes: Photo;
}
/**
 * 
 * @export
 * @interface UpdateCoverLetterRequest
 */
export interface UpdateCoverLetterRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCoverLetterRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCoverLetterRequest
     */
    content?: string;
}
/**
 * 
 * @export
 * @interface UpdateCvCommentRequest
 */
export interface UpdateCvCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvCommentRequest
     */
    body?: string;
}
/**
 * 
 * @export
 * @interface UpdateCvCvSectionsRequest
 */
export interface UpdateCvCvSectionsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvCvSectionsRequest
     */
    direction?: UpdateCvCvSectionsRequestDirectionEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateCvCvSectionsRequestDirectionEnum {
    Forward = 'forward',
    Backward = 'backward'
}

/**
 * 
 * @export
 * @interface UpdateCvPageBreaksRequest
 */
export interface UpdateCvPageBreaksRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCvPageBreaksRequest
     */
    page_break?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvPageBreaksRequest
     */
    target_section_type?: UpdateCvPageBreaksRequestTargetSectionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateCvPageBreaksRequest
     */
    target_section_id?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateCvPageBreaksRequestTargetSectionTypeEnum {
    CvSectionText = 'CvSectionText',
    CvSectionDate = 'CvSectionDate',
    CvSectionSkill = 'CvSectionSkill',
    CvSectionLink = 'CvSectionLink',
    CvSectionGallery = 'CvSectionGallery'
}

/**
 * 
 * @export
 * @interface UpdateCvRequest
 */
export interface UpdateCvRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvRequest
     */
    publish_type?: UpdateCvRequestPublishTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvRequest
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvRequest
     */
    password_confirmation?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvRequest
     */
    original_path?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCvRequest
     */
    cv_design_template_id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvRequest
     */
    publish_date?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateCvRequestPublishTypeEnum {
    Open = 'open',
    OpenUnlisted = 'open_unlisted',
    OpenWithPw = 'open_with_pw',
    Secret = 'secret'
}

/**
 * 
 * @export
 * @interface UpdateCvSectionDateItemOrderRequest
 */
export interface UpdateCvSectionDateItemOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCvSectionDateItemOrderRequest
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface UpdateCvSectionDateItemRequest
 */
export interface UpdateCvSectionDateItemRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionDateItemRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionDateItemRequest
     */
    organization?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionDateItemRequest
     */
    website_url?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionDateItemRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionDateItemRequest
     */
    start_date_year?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionDateItemRequest
     */
    start_date_month?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionDateItemRequest
     */
    start_date_day?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionDateItemRequest
     */
    end_date_year?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionDateItemRequest
     */
    end_date_month?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionDateItemRequest
     */
    end_date_day?: string;
}
/**
 * 
 * @export
 * @interface UpdateCvSectionDateRequest
 */
export interface UpdateCvSectionDateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionDateRequest
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UpdateCvSectionGalleryItemOrderRequest
 */
export interface UpdateCvSectionGalleryItemOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCvSectionGalleryItemOrderRequest
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface UpdateCvSectionGalleryItemRequest
 */
export interface UpdateCvSectionGalleryItemRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionGalleryItemRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionGalleryItemRequest
     */
    page_break?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCvSectionGalleryItemRequest
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionGalleryItemRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionGalleryItemRequest
     */
    _url?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateCvSectionGalleryItemRequest
     */
    image?: object;
}
/**
 * 
 * @export
 * @interface UpdateCvSectionGalleryRequest
 */
export interface UpdateCvSectionGalleryRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionGalleryRequest
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UpdateCvSectionLinkItemOrderRequest
 */
export interface UpdateCvSectionLinkItemOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCvSectionLinkItemOrderRequest
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface UpdateCvSectionLinkItemRequest
 */
export interface UpdateCvSectionLinkItemRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionLinkItemRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionLinkItemRequest
     */
    page_break?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCvSectionLinkItemRequest
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionLinkItemRequest
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface UpdateCvSectionLinkRequest
 */
export interface UpdateCvSectionLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionLinkRequest
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UpdateCvSectionProfileRequest
 */
export interface UpdateCvSectionProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionProfileRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionProfileRequest
     */
    full_name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCvSectionProfileRequest
     */
    birthday_year?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCvSectionProfileRequest
     */
    birthday_month?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCvSectionProfileRequest
     */
    birthday_day?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionProfileRequest
     */
    sex?: UpdateCvSectionProfileRequestSexEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionProfileRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionProfileRequest
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionProfileRequest
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionProfileRequest
     */
    headline?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionProfileRequest
     */
    website_url?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateCvSectionProfileRequest
     */
    profile_image?: object;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCvSectionProfileRequest
     */
    remove_profile_image?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateCvSectionProfileRequestSexEnum {
    NotKnown = 'not_known',
    Male = 'male',
    Female = 'female',
    NotApplicable = 'not_applicable'
}

/**
 * 
 * @export
 * @interface UpdateCvSectionSkillItemOrderRequest
 */
export interface UpdateCvSectionSkillItemOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCvSectionSkillItemOrderRequest
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface UpdateCvSectionSkillItemRequest
 */
export interface UpdateCvSectionSkillItemRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionSkillItemRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionSkillItemRequest
     */
    page_break?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCvSectionSkillItemRequest
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionSkillItemRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCvSectionSkillItemRequest
     */
    strength?: number;
}
/**
 * 
 * @export
 * @interface UpdateCvSectionSkillRequest
 */
export interface UpdateCvSectionSkillRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionSkillRequest
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UpdateCvSectionTextRequest
 */
export interface UpdateCvSectionTextRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionTextRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCvSectionTextRequest
     */
    content?: string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    email: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    type: string;
    /**
     * 
     * @type {User}
     * @memberof UserResponse
     */
    attributes: User;
}

/**
 * ProffApi - axios parameter creator
 * @export
 */
export const ProffApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCoverLetterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoverLetter: async (body: CreateCoverLetterRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCoverLetter.');
            }
            const localVarPath = `/api/cover_letters`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCvFromCopyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvFromCopy: async (body: CreateCvFromCopyRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvFromCopy.');
            }
            const localVarPath = `/api/cv/new_copy`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCvFromExampleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvFromExample: async (body: CreateCvFromExampleRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvFromExample.');
            }
            const localVarPath = `/api/cv/new_example`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCvFromSampleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvFromSample: async (body: CreateCvFromSampleRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvFromSample.');
            }
            const localVarPath = `/api/cv/new_sample`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCvFromScratchRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvFromScratch: async (body: CreateCvFromScratchRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvFromScratch.');
            }
            const localVarPath = `/api/cv/new_scratch`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCvFromTemplateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvFromTemplate: async (body: CreateCvFromTemplateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvFromTemplate.');
            }
            const localVarPath = `/api/cv/new_template`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionDateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionDate: async (cvId: number, body: CreateCvSectionDateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling createCvSectionDate.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvSectionDate.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_dates`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {CreateCvSectionDateItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionDateItem: async (cvId: number, cvSectionDateId: number, body: CreateCvSectionDateItemRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling createCvSectionDateItem.');
            }
            // verify required parameter 'cvSectionDateId' is not null or undefined
            if (cvSectionDateId === null || cvSectionDateId === undefined) {
                throw new RequiredError('cvSectionDateId','Required parameter cvSectionDateId was null or undefined when calling createCvSectionDateItem.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvSectionDateItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_dates/{cv_section_date_id}/cv_section_date_items`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_date_id"}}`, encodeURIComponent(String(cvSectionDateId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionGalleryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionGallery: async (cvId: number, body: CreateCvSectionGalleryRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling createCvSectionGallery.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvSectionGallery.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_galleries`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {string} [title] 
         * @param {string} [pageBreak] 
         * @param {number} [position] 
         * @param {string} [description] 
         * @param {string} [url] 
         * @param {object} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionGalleryItem: async (cvId: number, cvSectionGalleryId: number, title?: string, pageBreak?: string, position?: number, description?: string, url?: string, image?: object, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling createCvSectionGalleryItem.');
            }
            // verify required parameter 'cvSectionGalleryId' is not null or undefined
            if (cvSectionGalleryId === null || cvSectionGalleryId === undefined) {
                throw new RequiredError('cvSectionGalleryId','Required parameter cvSectionGalleryId was null or undefined when calling createCvSectionGalleryItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_galleries/{cv_section_gallery_id}/cv_section_gallery_items`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_gallery_id"}}`, encodeURIComponent(String(cvSectionGalleryId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
    
            if (pageBreak !== undefined) { 
                localVarFormParams.append('page_break', pageBreak as any);
            }
    
            if (position !== undefined) { 
                localVarFormParams.append('position', position as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
            if (url !== undefined) { 
                localVarFormParams.append('_url', url as any);
            }
    
            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionLinkRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionLink: async (cvId: number, body: CreateCvSectionLinkRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling createCvSectionLink.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvSectionLink.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_links`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {CreateCvSectionLinkItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionLinkItem: async (cvId: number, cvSectionLinkId: number, body: CreateCvSectionLinkItemRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling createCvSectionLinkItem.');
            }
            // verify required parameter 'cvSectionLinkId' is not null or undefined
            if (cvSectionLinkId === null || cvSectionLinkId === undefined) {
                throw new RequiredError('cvSectionLinkId','Required parameter cvSectionLinkId was null or undefined when calling createCvSectionLinkItem.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvSectionLinkItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_links/{cv_section_link_id}/cv_section_link_items`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_link_id"}}`, encodeURIComponent(String(cvSectionLinkId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionSkillRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionSkill: async (cvId: number, body: CreateCvSectionSkillRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling createCvSectionSkill.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvSectionSkill.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_skills`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {CreateCvSectionSkillItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionSkillItem: async (cvId: number, cvSectionSkillId: number, body: CreateCvSectionSkillItemRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling createCvSectionSkillItem.');
            }
            // verify required parameter 'cvSectionSkillId' is not null or undefined
            if (cvSectionSkillId === null || cvSectionSkillId === undefined) {
                throw new RequiredError('cvSectionSkillId','Required parameter cvSectionSkillId was null or undefined when calling createCvSectionSkillItem.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvSectionSkillItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_skills/{cv_section_skill_id}/cv_section_skill_items`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_skill_id"}}`, encodeURIComponent(String(cvSectionSkillId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionTextRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionText: async (cvId: number, body: CreateCvSectionTextRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling createCvSectionText.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvSectionText.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_texts`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhoto: async (image?: object, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/photos`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/registration.json`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoverLetter: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCoverLetter.');
            }
            const localVarPath = `/api/cover_letters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCv: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCv.');
            }
            const localVarPath = `/api/cvs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionDate: async (cvId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling deleteCvSectionDate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCvSectionDate.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_dates/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionDateItem: async (cvId: number, cvSectionDateId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling deleteCvSectionDateItem.');
            }
            // verify required parameter 'cvSectionDateId' is not null or undefined
            if (cvSectionDateId === null || cvSectionDateId === undefined) {
                throw new RequiredError('cvSectionDateId','Required parameter cvSectionDateId was null or undefined when calling deleteCvSectionDateItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCvSectionDateItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_dates/{cv_section_date_id}/cv_section_date_items/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_date_id"}}`, encodeURIComponent(String(cvSectionDateId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionGallery: async (cvId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling deleteCvSectionGallery.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCvSectionGallery.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_galleries/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionGalleryItem: async (cvId: number, cvSectionGalleryId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling deleteCvSectionGalleryItem.');
            }
            // verify required parameter 'cvSectionGalleryId' is not null or undefined
            if (cvSectionGalleryId === null || cvSectionGalleryId === undefined) {
                throw new RequiredError('cvSectionGalleryId','Required parameter cvSectionGalleryId was null or undefined when calling deleteCvSectionGalleryItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCvSectionGalleryItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_galleries/{cv_section_gallery_id}/cv_section_gallery_items/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_gallery_id"}}`, encodeURIComponent(String(cvSectionGalleryId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionLink: async (cvId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling deleteCvSectionLink.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCvSectionLink.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_links/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionLinkItem: async (cvId: number, cvSectionLinkId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling deleteCvSectionLinkItem.');
            }
            // verify required parameter 'cvSectionLinkId' is not null or undefined
            if (cvSectionLinkId === null || cvSectionLinkId === undefined) {
                throw new RequiredError('cvSectionLinkId','Required parameter cvSectionLinkId was null or undefined when calling deleteCvSectionLinkItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCvSectionLinkItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_links/{cv_section_link_id}/cv_section_link_items/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_link_id"}}`, encodeURIComponent(String(cvSectionLinkId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionSkill: async (cvId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling deleteCvSectionSkill.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCvSectionSkill.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_skills/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionSkillItem: async (cvId: number, cvSectionSkillId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling deleteCvSectionSkillItem.');
            }
            // verify required parameter 'cvSectionSkillId' is not null or undefined
            if (cvSectionSkillId === null || cvSectionSkillId === undefined) {
                throw new RequiredError('cvSectionSkillId','Required parameter cvSectionSkillId was null or undefined when calling deleteCvSectionSkillItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCvSectionSkillItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_skills/{cv_section_skill_id}/cv_section_skill_items/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_skill_id"}}`, encodeURIComponent(String(cvSectionSkillId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionText: async (cvId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling deleteCvSectionText.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCvSectionText.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_texts/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverLetter: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCoverLetter.');
            }
            const localVarPath = `/api/cover_letters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCv: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCv.');
            }
            const localVarPath = `/api/cvs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionDate: async (cvId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling getCvSectionDate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCvSectionDate.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_dates/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionDateItem: async (cvId: number, cvSectionDateId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling getCvSectionDateItem.');
            }
            // verify required parameter 'cvSectionDateId' is not null or undefined
            if (cvSectionDateId === null || cvSectionDateId === undefined) {
                throw new RequiredError('cvSectionDateId','Required parameter cvSectionDateId was null or undefined when calling getCvSectionDateItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCvSectionDateItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_dates/{cv_section_date_id}/cv_section_date_items/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_date_id"}}`, encodeURIComponent(String(cvSectionDateId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionGallery: async (cvId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling getCvSectionGallery.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCvSectionGallery.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_galleries/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionGalleryItem: async (cvId: number, cvSectionGalleryId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling getCvSectionGalleryItem.');
            }
            // verify required parameter 'cvSectionGalleryId' is not null or undefined
            if (cvSectionGalleryId === null || cvSectionGalleryId === undefined) {
                throw new RequiredError('cvSectionGalleryId','Required parameter cvSectionGalleryId was null or undefined when calling getCvSectionGalleryItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCvSectionGalleryItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_galleries/{cv_section_gallery_id}/cv_section_gallery_items/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_gallery_id"}}`, encodeURIComponent(String(cvSectionGalleryId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionLink: async (cvId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling getCvSectionLink.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCvSectionLink.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_links/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionLinkItem: async (cvId: number, cvSectionLinkId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling getCvSectionLinkItem.');
            }
            // verify required parameter 'cvSectionLinkId' is not null or undefined
            if (cvSectionLinkId === null || cvSectionLinkId === undefined) {
                throw new RequiredError('cvSectionLinkId','Required parameter cvSectionLinkId was null or undefined when calling getCvSectionLinkItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCvSectionLinkItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_links/{cv_section_link_id}/cv_section_link_items/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_link_id"}}`, encodeURIComponent(String(cvSectionLinkId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionProfile: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCvSectionProfile.');
            }
            const localVarPath = `/api/cvs/{id}/cv_section_profile`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionSkill: async (cvId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling getCvSectionSkill.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCvSectionSkill.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_skills/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionSkillItem: async (cvId: number, cvSectionSkillId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling getCvSectionSkillItem.');
            }
            // verify required parameter 'cvSectionSkillId' is not null or undefined
            if (cvSectionSkillId === null || cvSectionSkillId === undefined) {
                throw new RequiredError('cvSectionSkillId','Required parameter cvSectionSkillId was null or undefined when calling getCvSectionSkillItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCvSectionSkillItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_skills/{cv_section_skill_id}/cv_section_skill_items/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_skill_id"}}`, encodeURIComponent(String(cvSectionSkillId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionText: async (cvId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling getCvSectionText.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCvSectionText.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_texts/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCoverLetters: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cover_letters`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvCvSections: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling listCvCvSections.');
            }
            const localVarPath = `/api/cvs/{id}/cv_cv_sections`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvDataTemplates: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cv_data_templates`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvDesignTemplateSamples: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cv_design_template_samples`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvDesignTemplates: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cv_design_templates`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvExamples: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cv_examples`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvSamples: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cv_samples`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvs: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cvs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateCoverLetterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverLetter: async (id: number, body: UpdateCoverLetterRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCoverLetter.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCoverLetter.');
            }
            const localVarPath = `/api/cover_letters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateCvRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCv: async (id: number, body: UpdateCvRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCv.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCv.');
            }
            const localVarPath = `/api/cvs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvCvSectionsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvCvSections: async (cvId: number, id: number, body: UpdateCvCvSectionsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvCvSections.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvCvSections.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvCvSections.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_cv_sections/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {UpdateCvPageBreaksRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvPageBreaks: async (cvId: number, body: UpdateCvPageBreaksRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvPageBreaks.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvPageBreaks.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_page_breaks`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionDateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionDate: async (cvId: number, id: number, body: UpdateCvSectionDateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionDate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionDate.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvSectionDate.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_dates/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {number} id 
         * @param {UpdateCvSectionDateItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionDateItem: async (cvId: number, cvSectionDateId: number, id: number, body: UpdateCvSectionDateItemRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionDateItem.');
            }
            // verify required parameter 'cvSectionDateId' is not null or undefined
            if (cvSectionDateId === null || cvSectionDateId === undefined) {
                throw new RequiredError('cvSectionDateId','Required parameter cvSectionDateId was null or undefined when calling updateCvSectionDateItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionDateItem.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvSectionDateItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_dates/{cv_section_date_id}/cv_section_date_items/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_date_id"}}`, encodeURIComponent(String(cvSectionDateId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {number} id 
         * @param {UpdateCvSectionDateItemOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionDateItemOrder: async (cvId: number, cvSectionDateId: number, id: number, body: UpdateCvSectionDateItemOrderRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionDateItemOrder.');
            }
            // verify required parameter 'cvSectionDateId' is not null or undefined
            if (cvSectionDateId === null || cvSectionDateId === undefined) {
                throw new RequiredError('cvSectionDateId','Required parameter cvSectionDateId was null or undefined when calling updateCvSectionDateItemOrder.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionDateItemOrder.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvSectionDateItemOrder.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_dates/{cv_section_date_id}/cv_section_date_items/{id}/cv_section_date_item_orders`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_date_id"}}`, encodeURIComponent(String(cvSectionDateId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionGalleryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionGallery: async (cvId: number, id: number, body: UpdateCvSectionGalleryRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionGallery.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionGallery.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvSectionGallery.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_galleries/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {number} id 
         * @param {string} [title] 
         * @param {string} [pageBreak] 
         * @param {number} [position] 
         * @param {string} [description] 
         * @param {string} [url] 
         * @param {object} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionGalleryItem: async (cvId: number, cvSectionGalleryId: number, id: number, title?: string, pageBreak?: string, position?: number, description?: string, url?: string, image?: object, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionGalleryItem.');
            }
            // verify required parameter 'cvSectionGalleryId' is not null or undefined
            if (cvSectionGalleryId === null || cvSectionGalleryId === undefined) {
                throw new RequiredError('cvSectionGalleryId','Required parameter cvSectionGalleryId was null or undefined when calling updateCvSectionGalleryItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionGalleryItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_galleries/{cv_section_gallery_id}/cv_section_gallery_items/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_gallery_id"}}`, encodeURIComponent(String(cvSectionGalleryId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
    
            if (pageBreak !== undefined) { 
                localVarFormParams.append('page_break', pageBreak as any);
            }
    
            if (position !== undefined) { 
                localVarFormParams.append('position', position as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
            if (url !== undefined) { 
                localVarFormParams.append('_url', url as any);
            }
    
            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {number} id 
         * @param {UpdateCvSectionGalleryItemOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionGalleryItemOrder: async (cvId: number, cvSectionGalleryId: number, id: number, body: UpdateCvSectionGalleryItemOrderRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionGalleryItemOrder.');
            }
            // verify required parameter 'cvSectionGalleryId' is not null or undefined
            if (cvSectionGalleryId === null || cvSectionGalleryId === undefined) {
                throw new RequiredError('cvSectionGalleryId','Required parameter cvSectionGalleryId was null or undefined when calling updateCvSectionGalleryItemOrder.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionGalleryItemOrder.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvSectionGalleryItemOrder.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_galleries/{cv_section_gallery_id}/cv_section_gallery_items/{id}/cv_section_gallery_item_orders`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_gallery_id"}}`, encodeURIComponent(String(cvSectionGalleryId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionLinkRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionLink: async (cvId: number, id: number, body: UpdateCvSectionLinkRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionLink.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionLink.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvSectionLink.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_links/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {number} id 
         * @param {UpdateCvSectionLinkItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionLinkItem: async (cvId: number, cvSectionLinkId: number, id: number, body: UpdateCvSectionLinkItemRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionLinkItem.');
            }
            // verify required parameter 'cvSectionLinkId' is not null or undefined
            if (cvSectionLinkId === null || cvSectionLinkId === undefined) {
                throw new RequiredError('cvSectionLinkId','Required parameter cvSectionLinkId was null or undefined when calling updateCvSectionLinkItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionLinkItem.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvSectionLinkItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_links/{cv_section_link_id}/cv_section_link_items/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_link_id"}}`, encodeURIComponent(String(cvSectionLinkId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {number} id 
         * @param {UpdateCvSectionLinkItemOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionLinkItemOrder: async (cvId: number, cvSectionLinkId: number, id: number, body: UpdateCvSectionLinkItemOrderRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionLinkItemOrder.');
            }
            // verify required parameter 'cvSectionLinkId' is not null or undefined
            if (cvSectionLinkId === null || cvSectionLinkId === undefined) {
                throw new RequiredError('cvSectionLinkId','Required parameter cvSectionLinkId was null or undefined when calling updateCvSectionLinkItemOrder.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionLinkItemOrder.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvSectionLinkItemOrder.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_links/{cv_section_link_id}/cv_section_link_items/{id}/cv_section_link_item_orders`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_link_id"}}`, encodeURIComponent(String(cvSectionLinkId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [title] 
         * @param {string} [fullName] 
         * @param {number} [birthdayYear] 
         * @param {number} [birthdayMonth] 
         * @param {number} [birthdayDay] 
         * @param {string} [sex] 
         * @param {string} [email] 
         * @param {string} [phoneNumber] 
         * @param {string} [location] 
         * @param {string} [headline] 
         * @param {string} [websiteUrl] 
         * @param {object} [profileImage] 
         * @param {boolean} [removeProfileImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionProfile: async (id: number, title?: string, fullName?: string, birthdayYear?: number, birthdayMonth?: number, birthdayDay?: number, sex?: string, email?: string, phoneNumber?: string, location?: string, headline?: string, websiteUrl?: string, profileImage?: object, removeProfileImage?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionProfile.');
            }
            const localVarPath = `/api/cvs/{id}/cv_section_profile`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
    
            if (fullName !== undefined) { 
                localVarFormParams.append('full_name', fullName as any);
            }
    
            if (birthdayYear !== undefined) { 
                localVarFormParams.append('birthday_year', birthdayYear as any);
            }
    
            if (birthdayMonth !== undefined) { 
                localVarFormParams.append('birthday_month', birthdayMonth as any);
            }
    
            if (birthdayDay !== undefined) { 
                localVarFormParams.append('birthday_day', birthdayDay as any);
            }
    
            if (sex !== undefined) { 
                localVarFormParams.append('sex', sex as any);
            }
    
            if (email !== undefined) { 
                localVarFormParams.append('email', email as any);
            }
    
            if (phoneNumber !== undefined) { 
                localVarFormParams.append('phone_number', phoneNumber as any);
            }
    
            if (location !== undefined) { 
                localVarFormParams.append('location', location as any);
            }
    
            if (headline !== undefined) { 
                localVarFormParams.append('headline', headline as any);
            }
    
            if (websiteUrl !== undefined) { 
                localVarFormParams.append('website_url', websiteUrl as any);
            }
    
            if (profileImage !== undefined) { 
                localVarFormParams.append('profile_image', profileImage as any);
            }
    
            if (removeProfileImage !== undefined) { 
                localVarFormParams.append('remove_profile_image', removeProfileImage as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionSkillRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionSkill: async (cvId: number, id: number, body: UpdateCvSectionSkillRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionSkill.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionSkill.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvSectionSkill.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_skills/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {number} id 
         * @param {UpdateCvSectionSkillItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionSkillItem: async (cvId: number, cvSectionSkillId: number, id: number, body: UpdateCvSectionSkillItemRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionSkillItem.');
            }
            // verify required parameter 'cvSectionSkillId' is not null or undefined
            if (cvSectionSkillId === null || cvSectionSkillId === undefined) {
                throw new RequiredError('cvSectionSkillId','Required parameter cvSectionSkillId was null or undefined when calling updateCvSectionSkillItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionSkillItem.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvSectionSkillItem.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_skills/{cv_section_skill_id}/cv_section_skill_items/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_skill_id"}}`, encodeURIComponent(String(cvSectionSkillId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {number} id 
         * @param {UpdateCvSectionSkillItemOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionSkillItemOrder: async (cvId: number, cvSectionSkillId: number, id: number, body: UpdateCvSectionSkillItemOrderRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionSkillItemOrder.');
            }
            // verify required parameter 'cvSectionSkillId' is not null or undefined
            if (cvSectionSkillId === null || cvSectionSkillId === undefined) {
                throw new RequiredError('cvSectionSkillId','Required parameter cvSectionSkillId was null or undefined when calling updateCvSectionSkillItemOrder.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionSkillItemOrder.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvSectionSkillItemOrder.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_skills/{cv_section_skill_id}/cv_section_skill_items/{id}/cv_section_skill_item_orders`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"cv_section_skill_id"}}`, encodeURIComponent(String(cvSectionSkillId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionTextRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionText: async (cvId: number, id: number, body: UpdateCvSectionTextRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvSectionText.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvSectionText.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvSectionText.');
            }
            const localVarPath = `/api/cvs/{cv_id}/cv_section_texts/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProffApi - functional programming interface
 * @export
 */
export const ProffApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCoverLetterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCoverLetter(body: CreateCoverLetterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20110>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCoverLetter(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {CreateCvFromCopyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvFromCopy(body: CreateCvFromCopyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvFromCopy(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {CreateCvFromExampleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvFromExample(body: CreateCvFromExampleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvFromExample(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {CreateCvFromSampleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvFromSample(body: CreateCvFromSampleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvFromSample(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {CreateCvFromScratchRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvFromScratch(body: CreateCvFromScratchRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvFromScratch(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {CreateCvFromTemplateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvFromTemplate(body: CreateCvFromTemplateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvFromTemplate(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionDateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvSectionDate(cvId: number, body: CreateCvSectionDateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2012>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvSectionDate(cvId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {CreateCvSectionDateItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvSectionDateItem(cvId: number, cvSectionDateId: number, body: CreateCvSectionDateItemRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2013>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvSectionDateItem(cvId, cvSectionDateId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionGalleryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvSectionGallery(cvId: number, body: CreateCvSectionGalleryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2018>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvSectionGallery(cvId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {string} [title] 
         * @param {string} [pageBreak] 
         * @param {number} [position] 
         * @param {string} [description] 
         * @param {string} [url] 
         * @param {object} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvSectionGalleryItem(cvId: number, cvSectionGalleryId: number, title?: string, pageBreak?: string, position?: number, description?: string, url?: string, image?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2019>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvSectionGalleryItem(cvId, cvSectionGalleryId, title, pageBreak, position, description, url, image, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionLinkRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvSectionLink(cvId: number, body: CreateCvSectionLinkRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2016>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvSectionLink(cvId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {CreateCvSectionLinkItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvSectionLinkItem(cvId: number, cvSectionLinkId: number, body: CreateCvSectionLinkItemRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2017>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvSectionLinkItem(cvId, cvSectionLinkId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionSkillRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvSectionSkill(cvId: number, body: CreateCvSectionSkillRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2014>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvSectionSkill(cvId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {CreateCvSectionSkillItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvSectionSkillItem(cvId: number, cvSectionSkillId: number, body: CreateCvSectionSkillItemRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2015>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvSectionSkillItem(cvId, cvSectionSkillId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionTextRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvSectionText(cvId: number, body: CreateCvSectionTextRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2011>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createCvSectionText(cvId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {object} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPhoto(image?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse201>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).createPhoto(image, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccount(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).deleteAccount(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCoverLetter(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).deleteCoverLetter(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCv(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).deleteCv(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSectionDate(cvId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).deleteCvSectionDate(cvId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSectionDateItem(cvId: number, cvSectionDateId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).deleteCvSectionDateItem(cvId, cvSectionDateId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSectionGallery(cvId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).deleteCvSectionGallery(cvId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSectionGalleryItem(cvId: number, cvSectionGalleryId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).deleteCvSectionGalleryItem(cvId, cvSectionGalleryId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSectionLink(cvId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).deleteCvSectionLink(cvId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSectionLinkItem(cvId: number, cvSectionLinkId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).deleteCvSectionLinkItem(cvId, cvSectionLinkId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSectionSkill(cvId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).deleteCvSectionSkill(cvId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSectionSkillItem(cvId: number, cvSectionSkillId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).deleteCvSectionSkillItem(cvId, cvSectionSkillId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSectionText(cvId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).deleteCvSectionText(cvId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCoverLetter(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20110>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).getCoverLetter(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCv(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2007>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).getCv(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSectionDate(cvId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2012>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).getCvSectionDate(cvId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSectionDateItem(cvId: number, cvSectionDateId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2013>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).getCvSectionDateItem(cvId, cvSectionDateId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSectionGallery(cvId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2018>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).getCvSectionGallery(cvId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSectionGalleryItem(cvId: number, cvSectionGalleryId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2019>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).getCvSectionGalleryItem(cvId, cvSectionGalleryId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSectionLink(cvId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2016>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).getCvSectionLink(cvId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSectionLinkItem(cvId: number, cvSectionLinkId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2017>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).getCvSectionLinkItem(cvId, cvSectionLinkId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSectionProfile(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2009>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).getCvSectionProfile(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSectionSkill(cvId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2014>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).getCvSectionSkill(cvId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSectionSkillItem(cvId: number, cvSectionSkillId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2015>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).getCvSectionSkillItem(cvId, cvSectionSkillId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSectionText(cvId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2011>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).getCvSectionText(cvId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCoverLetters(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20010>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).listCoverLetters(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCvCvSections(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).listCvCvSections(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCvDataTemplates(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).listCvDataTemplates(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCvDesignTemplateSamples(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).listCvDesignTemplateSamples(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCvDesignTemplates(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2004>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).listCvDesignTemplates(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCvExamples(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).listCvExamples(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCvSamples(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).listCvSamples(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCvs(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2006>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).listCvs(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateCoverLetterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCoverLetter(id: number, body: UpdateCoverLetterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20110>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCoverLetter(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateCvRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCv(id: number, body: UpdateCvRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCv(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvCvSectionsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvCvSections(cvId: number, id: number, body: UpdateCvCvSectionsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvCvSections(cvId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {UpdateCvPageBreaksRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvPageBreaks(cvId: number, body: UpdateCvPageBreaksRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvPageBreaks(cvId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionDateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionDate(cvId: number, id: number, body: UpdateCvSectionDateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2012>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionDate(cvId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {number} id 
         * @param {UpdateCvSectionDateItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionDateItem(cvId: number, cvSectionDateId: number, id: number, body: UpdateCvSectionDateItemRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2013>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionDateItem(cvId, cvSectionDateId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {number} id 
         * @param {UpdateCvSectionDateItemOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionDateItemOrder(cvId: number, cvSectionDateId: number, id: number, body: UpdateCvSectionDateItemOrderRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2013>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionDateItemOrder(cvId, cvSectionDateId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionGalleryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionGallery(cvId: number, id: number, body: UpdateCvSectionGalleryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2018>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionGallery(cvId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {number} id 
         * @param {string} [title] 
         * @param {string} [pageBreak] 
         * @param {number} [position] 
         * @param {string} [description] 
         * @param {string} [url] 
         * @param {object} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionGalleryItem(cvId: number, cvSectionGalleryId: number, id: number, title?: string, pageBreak?: string, position?: number, description?: string, url?: string, image?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2019>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionGalleryItem(cvId, cvSectionGalleryId, id, title, pageBreak, position, description, url, image, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {number} id 
         * @param {UpdateCvSectionGalleryItemOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionGalleryItemOrder(cvId: number, cvSectionGalleryId: number, id: number, body: UpdateCvSectionGalleryItemOrderRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2019>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionGalleryItemOrder(cvId, cvSectionGalleryId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionLinkRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionLink(cvId: number, id: number, body: UpdateCvSectionLinkRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2016>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionLink(cvId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {number} id 
         * @param {UpdateCvSectionLinkItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionLinkItem(cvId: number, cvSectionLinkId: number, id: number, body: UpdateCvSectionLinkItemRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2017>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionLinkItem(cvId, cvSectionLinkId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {number} id 
         * @param {UpdateCvSectionLinkItemOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionLinkItemOrder(cvId: number, cvSectionLinkId: number, id: number, body: UpdateCvSectionLinkItemOrderRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2017>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionLinkItemOrder(cvId, cvSectionLinkId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [title] 
         * @param {string} [fullName] 
         * @param {number} [birthdayYear] 
         * @param {number} [birthdayMonth] 
         * @param {number} [birthdayDay] 
         * @param {string} [sex] 
         * @param {string} [email] 
         * @param {string} [phoneNumber] 
         * @param {string} [location] 
         * @param {string} [headline] 
         * @param {string} [websiteUrl] 
         * @param {object} [profileImage] 
         * @param {boolean} [removeProfileImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionProfile(id: number, title?: string, fullName?: string, birthdayYear?: number, birthdayMonth?: number, birthdayDay?: number, sex?: string, email?: string, phoneNumber?: string, location?: string, headline?: string, websiteUrl?: string, profileImage?: object, removeProfileImage?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2009>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionProfile(id, title, fullName, birthdayYear, birthdayMonth, birthdayDay, sex, email, phoneNumber, location, headline, websiteUrl, profileImage, removeProfileImage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionSkillRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionSkill(cvId: number, id: number, body: UpdateCvSectionSkillRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2014>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionSkill(cvId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {number} id 
         * @param {UpdateCvSectionSkillItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionSkillItem(cvId: number, cvSectionSkillId: number, id: number, body: UpdateCvSectionSkillItemRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2015>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionSkillItem(cvId, cvSectionSkillId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {number} id 
         * @param {UpdateCvSectionSkillItemOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionSkillItemOrder(cvId: number, cvSectionSkillId: number, id: number, body: UpdateCvSectionSkillItemOrderRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2015>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionSkillItemOrder(cvId, cvSectionSkillId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionTextRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSectionText(cvId: number, id: number, body: UpdateCvSectionTextRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2011>> {
            const localVarAxiosArgs = await ProffApiAxiosParamCreator(configuration).updateCvSectionText(cvId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProffApi - factory interface
 * @export
 */
export const ProffApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {CreateCoverLetterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoverLetter(body: CreateCoverLetterRequest, options?: any): AxiosPromise<InlineResponse20110> {
            return ProffApiFp(configuration).createCoverLetter(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCvFromCopyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvFromCopy(body: CreateCvFromCopyRequest, options?: any): AxiosPromise<InlineResponse2008> {
            return ProffApiFp(configuration).createCvFromCopy(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCvFromExampleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvFromExample(body: CreateCvFromExampleRequest, options?: any): AxiosPromise<InlineResponse2008> {
            return ProffApiFp(configuration).createCvFromExample(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCvFromSampleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvFromSample(body: CreateCvFromSampleRequest, options?: any): AxiosPromise<InlineResponse2008> {
            return ProffApiFp(configuration).createCvFromSample(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCvFromScratchRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvFromScratch(body: CreateCvFromScratchRequest, options?: any): AxiosPromise<InlineResponse2008> {
            return ProffApiFp(configuration).createCvFromScratch(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCvFromTemplateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvFromTemplate(body: CreateCvFromTemplateRequest, options?: any): AxiosPromise<InlineResponse2008> {
            return ProffApiFp(configuration).createCvFromTemplate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionDateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionDate(cvId: number, body: CreateCvSectionDateRequest, options?: any): AxiosPromise<InlineResponse2012> {
            return ProffApiFp(configuration).createCvSectionDate(cvId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {CreateCvSectionDateItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionDateItem(cvId: number, cvSectionDateId: number, body: CreateCvSectionDateItemRequest, options?: any): AxiosPromise<InlineResponse2013> {
            return ProffApiFp(configuration).createCvSectionDateItem(cvId, cvSectionDateId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionGalleryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionGallery(cvId: number, body: CreateCvSectionGalleryRequest, options?: any): AxiosPromise<InlineResponse2018> {
            return ProffApiFp(configuration).createCvSectionGallery(cvId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {string} [title] 
         * @param {string} [pageBreak] 
         * @param {number} [position] 
         * @param {string} [description] 
         * @param {string} [url] 
         * @param {object} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionGalleryItem(cvId: number, cvSectionGalleryId: number, title?: string, pageBreak?: string, position?: number, description?: string, url?: string, image?: object, options?: any): AxiosPromise<InlineResponse2019> {
            return ProffApiFp(configuration).createCvSectionGalleryItem(cvId, cvSectionGalleryId, title, pageBreak, position, description, url, image, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionLinkRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionLink(cvId: number, body: CreateCvSectionLinkRequest, options?: any): AxiosPromise<InlineResponse2016> {
            return ProffApiFp(configuration).createCvSectionLink(cvId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {CreateCvSectionLinkItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionLinkItem(cvId: number, cvSectionLinkId: number, body: CreateCvSectionLinkItemRequest, options?: any): AxiosPromise<InlineResponse2017> {
            return ProffApiFp(configuration).createCvSectionLinkItem(cvId, cvSectionLinkId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionSkillRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionSkill(cvId: number, body: CreateCvSectionSkillRequest, options?: any): AxiosPromise<InlineResponse2014> {
            return ProffApiFp(configuration).createCvSectionSkill(cvId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {CreateCvSectionSkillItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionSkillItem(cvId: number, cvSectionSkillId: number, body: CreateCvSectionSkillItemRequest, options?: any): AxiosPromise<InlineResponse2015> {
            return ProffApiFp(configuration).createCvSectionSkillItem(cvId, cvSectionSkillId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvSectionTextRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSectionText(cvId: number, body: CreateCvSectionTextRequest, options?: any): AxiosPromise<InlineResponse2011> {
            return ProffApiFp(configuration).createCvSectionText(cvId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhoto(image?: object, options?: any): AxiosPromise<InlineResponse201> {
            return ProffApiFp(configuration).createPhoto(image, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(options?: any): AxiosPromise<object> {
            return ProffApiFp(configuration).deleteAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoverLetter(id: number, options?: any): AxiosPromise<object> {
            return ProffApiFp(configuration).deleteCoverLetter(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCv(id: number, options?: any): AxiosPromise<object> {
            return ProffApiFp(configuration).deleteCv(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionDate(cvId: number, id: number, options?: any): AxiosPromise<object> {
            return ProffApiFp(configuration).deleteCvSectionDate(cvId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionDateItem(cvId: number, cvSectionDateId: number, id: number, options?: any): AxiosPromise<object> {
            return ProffApiFp(configuration).deleteCvSectionDateItem(cvId, cvSectionDateId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionGallery(cvId: number, id: number, options?: any): AxiosPromise<object> {
            return ProffApiFp(configuration).deleteCvSectionGallery(cvId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionGalleryItem(cvId: number, cvSectionGalleryId: number, id: number, options?: any): AxiosPromise<object> {
            return ProffApiFp(configuration).deleteCvSectionGalleryItem(cvId, cvSectionGalleryId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionLink(cvId: number, id: number, options?: any): AxiosPromise<object> {
            return ProffApiFp(configuration).deleteCvSectionLink(cvId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionLinkItem(cvId: number, cvSectionLinkId: number, id: number, options?: any): AxiosPromise<object> {
            return ProffApiFp(configuration).deleteCvSectionLinkItem(cvId, cvSectionLinkId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionSkill(cvId: number, id: number, options?: any): AxiosPromise<object> {
            return ProffApiFp(configuration).deleteCvSectionSkill(cvId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionSkillItem(cvId: number, cvSectionSkillId: number, id: number, options?: any): AxiosPromise<object> {
            return ProffApiFp(configuration).deleteCvSectionSkillItem(cvId, cvSectionSkillId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSectionText(cvId: number, id: number, options?: any): AxiosPromise<object> {
            return ProffApiFp(configuration).deleteCvSectionText(cvId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverLetter(id: number, options?: any): AxiosPromise<InlineResponse20110> {
            return ProffApiFp(configuration).getCoverLetter(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCv(id: number, options?: any): AxiosPromise<InlineResponse2007> {
            return ProffApiFp(configuration).getCv(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionDate(cvId: number, id: number, options?: any): AxiosPromise<InlineResponse2012> {
            return ProffApiFp(configuration).getCvSectionDate(cvId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionDateItem(cvId: number, cvSectionDateId: number, id: number, options?: any): AxiosPromise<InlineResponse2013> {
            return ProffApiFp(configuration).getCvSectionDateItem(cvId, cvSectionDateId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionGallery(cvId: number, id: number, options?: any): AxiosPromise<InlineResponse2018> {
            return ProffApiFp(configuration).getCvSectionGallery(cvId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionGalleryItem(cvId: number, cvSectionGalleryId: number, id: number, options?: any): AxiosPromise<InlineResponse2019> {
            return ProffApiFp(configuration).getCvSectionGalleryItem(cvId, cvSectionGalleryId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionLink(cvId: number, id: number, options?: any): AxiosPromise<InlineResponse2016> {
            return ProffApiFp(configuration).getCvSectionLink(cvId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionLinkItem(cvId: number, cvSectionLinkId: number, id: number, options?: any): AxiosPromise<InlineResponse2017> {
            return ProffApiFp(configuration).getCvSectionLinkItem(cvId, cvSectionLinkId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionProfile(id: number, options?: any): AxiosPromise<InlineResponse2009> {
            return ProffApiFp(configuration).getCvSectionProfile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionSkill(cvId: number, id: number, options?: any): AxiosPromise<InlineResponse2014> {
            return ProffApiFp(configuration).getCvSectionSkill(cvId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionSkillItem(cvId: number, cvSectionSkillId: number, id: number, options?: any): AxiosPromise<InlineResponse2015> {
            return ProffApiFp(configuration).getCvSectionSkillItem(cvId, cvSectionSkillId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSectionText(cvId: number, id: number, options?: any): AxiosPromise<InlineResponse2011> {
            return ProffApiFp(configuration).getCvSectionText(cvId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCoverLetters(options?: any): AxiosPromise<InlineResponse20010> {
            return ProffApiFp(configuration).listCoverLetters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvCvSections(id: number, options?: any): AxiosPromise<InlineResponse2005> {
            return ProffApiFp(configuration).listCvCvSections(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvDataTemplates(options?: any): AxiosPromise<InlineResponse2002> {
            return ProffApiFp(configuration).listCvDataTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvDesignTemplateSamples(options?: any): AxiosPromise<InlineResponse2003> {
            return ProffApiFp(configuration).listCvDesignTemplateSamples(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvDesignTemplates(options?: any): AxiosPromise<InlineResponse2004> {
            return ProffApiFp(configuration).listCvDesignTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvExamples(options?: any): AxiosPromise<InlineResponse2001> {
            return ProffApiFp(configuration).listCvExamples(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvSamples(options?: any): AxiosPromise<InlineResponse200> {
            return ProffApiFp(configuration).listCvSamples(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvs(options?: any): AxiosPromise<InlineResponse2006> {
            return ProffApiFp(configuration).listCvs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateCoverLetterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverLetter(id: number, body: UpdateCoverLetterRequest, options?: any): AxiosPromise<InlineResponse20110> {
            return ProffApiFp(configuration).updateCoverLetter(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateCvRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCv(id: number, body: UpdateCvRequest, options?: any): AxiosPromise<InlineResponse2008> {
            return ProffApiFp(configuration).updateCv(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvCvSectionsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvCvSections(cvId: number, id: number, body: UpdateCvCvSectionsRequest, options?: any): AxiosPromise<InlineResponse2005> {
            return ProffApiFp(configuration).updateCvCvSections(cvId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {UpdateCvPageBreaksRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvPageBreaks(cvId: number, body: UpdateCvPageBreaksRequest, options?: any): AxiosPromise<InlineResponse2005> {
            return ProffApiFp(configuration).updateCvPageBreaks(cvId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionDateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionDate(cvId: number, id: number, body: UpdateCvSectionDateRequest, options?: any): AxiosPromise<InlineResponse2012> {
            return ProffApiFp(configuration).updateCvSectionDate(cvId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {number} id 
         * @param {UpdateCvSectionDateItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionDateItem(cvId: number, cvSectionDateId: number, id: number, body: UpdateCvSectionDateItemRequest, options?: any): AxiosPromise<InlineResponse2013> {
            return ProffApiFp(configuration).updateCvSectionDateItem(cvId, cvSectionDateId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionDateId 
         * @param {number} id 
         * @param {UpdateCvSectionDateItemOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionDateItemOrder(cvId: number, cvSectionDateId: number, id: number, body: UpdateCvSectionDateItemOrderRequest, options?: any): AxiosPromise<InlineResponse2013> {
            return ProffApiFp(configuration).updateCvSectionDateItemOrder(cvId, cvSectionDateId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionGalleryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionGallery(cvId: number, id: number, body: UpdateCvSectionGalleryRequest, options?: any): AxiosPromise<InlineResponse2018> {
            return ProffApiFp(configuration).updateCvSectionGallery(cvId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {number} id 
         * @param {string} [title] 
         * @param {string} [pageBreak] 
         * @param {number} [position] 
         * @param {string} [description] 
         * @param {string} [url] 
         * @param {object} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionGalleryItem(cvId: number, cvSectionGalleryId: number, id: number, title?: string, pageBreak?: string, position?: number, description?: string, url?: string, image?: object, options?: any): AxiosPromise<InlineResponse2019> {
            return ProffApiFp(configuration).updateCvSectionGalleryItem(cvId, cvSectionGalleryId, id, title, pageBreak, position, description, url, image, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionGalleryId 
         * @param {number} id 
         * @param {UpdateCvSectionGalleryItemOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionGalleryItemOrder(cvId: number, cvSectionGalleryId: number, id: number, body: UpdateCvSectionGalleryItemOrderRequest, options?: any): AxiosPromise<InlineResponse2019> {
            return ProffApiFp(configuration).updateCvSectionGalleryItemOrder(cvId, cvSectionGalleryId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionLinkRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionLink(cvId: number, id: number, body: UpdateCvSectionLinkRequest, options?: any): AxiosPromise<InlineResponse2016> {
            return ProffApiFp(configuration).updateCvSectionLink(cvId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {number} id 
         * @param {UpdateCvSectionLinkItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionLinkItem(cvId: number, cvSectionLinkId: number, id: number, body: UpdateCvSectionLinkItemRequest, options?: any): AxiosPromise<InlineResponse2017> {
            return ProffApiFp(configuration).updateCvSectionLinkItem(cvId, cvSectionLinkId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionLinkId 
         * @param {number} id 
         * @param {UpdateCvSectionLinkItemOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionLinkItemOrder(cvId: number, cvSectionLinkId: number, id: number, body: UpdateCvSectionLinkItemOrderRequest, options?: any): AxiosPromise<InlineResponse2017> {
            return ProffApiFp(configuration).updateCvSectionLinkItemOrder(cvId, cvSectionLinkId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [title] 
         * @param {string} [fullName] 
         * @param {number} [birthdayYear] 
         * @param {number} [birthdayMonth] 
         * @param {number} [birthdayDay] 
         * @param {string} [sex] 
         * @param {string} [email] 
         * @param {string} [phoneNumber] 
         * @param {string} [location] 
         * @param {string} [headline] 
         * @param {string} [websiteUrl] 
         * @param {object} [profileImage] 
         * @param {boolean} [removeProfileImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionProfile(id: number, title?: string, fullName?: string, birthdayYear?: number, birthdayMonth?: number, birthdayDay?: number, sex?: string, email?: string, phoneNumber?: string, location?: string, headline?: string, websiteUrl?: string, profileImage?: object, removeProfileImage?: boolean, options?: any): AxiosPromise<InlineResponse2009> {
            return ProffApiFp(configuration).updateCvSectionProfile(id, title, fullName, birthdayYear, birthdayMonth, birthdayDay, sex, email, phoneNumber, location, headline, websiteUrl, profileImage, removeProfileImage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionSkillRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionSkill(cvId: number, id: number, body: UpdateCvSectionSkillRequest, options?: any): AxiosPromise<InlineResponse2014> {
            return ProffApiFp(configuration).updateCvSectionSkill(cvId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {number} id 
         * @param {UpdateCvSectionSkillItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionSkillItem(cvId: number, cvSectionSkillId: number, id: number, body: UpdateCvSectionSkillItemRequest, options?: any): AxiosPromise<InlineResponse2015> {
            return ProffApiFp(configuration).updateCvSectionSkillItem(cvId, cvSectionSkillId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} cvSectionSkillId 
         * @param {number} id 
         * @param {UpdateCvSectionSkillItemOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionSkillItemOrder(cvId: number, cvSectionSkillId: number, id: number, body: UpdateCvSectionSkillItemOrderRequest, options?: any): AxiosPromise<InlineResponse2015> {
            return ProffApiFp(configuration).updateCvSectionSkillItemOrder(cvId, cvSectionSkillId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvSectionTextRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSectionText(cvId: number, id: number, body: UpdateCvSectionTextRequest, options?: any): AxiosPromise<InlineResponse2011> {
            return ProffApiFp(configuration).updateCvSectionText(cvId, id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProffApi - object-oriented interface
 * @export
 * @class ProffApi
 * @extends {BaseAPI}
 */
export class ProffApi extends BaseAPI {
    /**
     * 
     * @param {CreateCoverLetterRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCoverLetter(body: CreateCoverLetterRequest, options?: any) {
        return ProffApiFp(this.configuration).createCoverLetter(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCvFromCopyRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvFromCopy(body: CreateCvFromCopyRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvFromCopy(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCvFromExampleRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvFromExample(body: CreateCvFromExampleRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvFromExample(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCvFromSampleRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvFromSample(body: CreateCvFromSampleRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvFromSample(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCvFromScratchRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvFromScratch(body: CreateCvFromScratchRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvFromScratch(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCvFromTemplateRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvFromTemplate(body: CreateCvFromTemplateRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvFromTemplate(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {CreateCvSectionDateRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvSectionDate(cvId: number, body: CreateCvSectionDateRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvSectionDate(cvId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionDateId 
     * @param {CreateCvSectionDateItemRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvSectionDateItem(cvId: number, cvSectionDateId: number, body: CreateCvSectionDateItemRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvSectionDateItem(cvId, cvSectionDateId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {CreateCvSectionGalleryRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvSectionGallery(cvId: number, body: CreateCvSectionGalleryRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvSectionGallery(cvId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionGalleryId 
     * @param {string} [title] 
     * @param {string} [pageBreak] 
     * @param {number} [position] 
     * @param {string} [description] 
     * @param {string} [url] 
     * @param {object} [image] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvSectionGalleryItem(cvId: number, cvSectionGalleryId: number, title?: string, pageBreak?: string, position?: number, description?: string, url?: string, image?: object, options?: any) {
        return ProffApiFp(this.configuration).createCvSectionGalleryItem(cvId, cvSectionGalleryId, title, pageBreak, position, description, url, image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {CreateCvSectionLinkRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvSectionLink(cvId: number, body: CreateCvSectionLinkRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvSectionLink(cvId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionLinkId 
     * @param {CreateCvSectionLinkItemRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvSectionLinkItem(cvId: number, cvSectionLinkId: number, body: CreateCvSectionLinkItemRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvSectionLinkItem(cvId, cvSectionLinkId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {CreateCvSectionSkillRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvSectionSkill(cvId: number, body: CreateCvSectionSkillRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvSectionSkill(cvId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionSkillId 
     * @param {CreateCvSectionSkillItemRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvSectionSkillItem(cvId: number, cvSectionSkillId: number, body: CreateCvSectionSkillItemRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvSectionSkillItem(cvId, cvSectionSkillId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {CreateCvSectionTextRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createCvSectionText(cvId: number, body: CreateCvSectionTextRequest, options?: any) {
        return ProffApiFp(this.configuration).createCvSectionText(cvId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} [image] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public createPhoto(image?: object, options?: any) {
        return ProffApiFp(this.configuration).createPhoto(image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public deleteAccount(options?: any) {
        return ProffApiFp(this.configuration).deleteAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public deleteCoverLetter(id: number, options?: any) {
        return ProffApiFp(this.configuration).deleteCoverLetter(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public deleteCv(id: number, options?: any) {
        return ProffApiFp(this.configuration).deleteCv(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public deleteCvSectionDate(cvId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).deleteCvSectionDate(cvId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionDateId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public deleteCvSectionDateItem(cvId: number, cvSectionDateId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).deleteCvSectionDateItem(cvId, cvSectionDateId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public deleteCvSectionGallery(cvId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).deleteCvSectionGallery(cvId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionGalleryId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public deleteCvSectionGalleryItem(cvId: number, cvSectionGalleryId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).deleteCvSectionGalleryItem(cvId, cvSectionGalleryId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public deleteCvSectionLink(cvId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).deleteCvSectionLink(cvId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionLinkId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public deleteCvSectionLinkItem(cvId: number, cvSectionLinkId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).deleteCvSectionLinkItem(cvId, cvSectionLinkId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public deleteCvSectionSkill(cvId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).deleteCvSectionSkill(cvId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionSkillId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public deleteCvSectionSkillItem(cvId: number, cvSectionSkillId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).deleteCvSectionSkillItem(cvId, cvSectionSkillId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public deleteCvSectionText(cvId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).deleteCvSectionText(cvId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public getCoverLetter(id: number, options?: any) {
        return ProffApiFp(this.configuration).getCoverLetter(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public getCv(id: number, options?: any) {
        return ProffApiFp(this.configuration).getCv(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public getCvSectionDate(cvId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).getCvSectionDate(cvId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionDateId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public getCvSectionDateItem(cvId: number, cvSectionDateId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).getCvSectionDateItem(cvId, cvSectionDateId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public getCvSectionGallery(cvId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).getCvSectionGallery(cvId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionGalleryId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public getCvSectionGalleryItem(cvId: number, cvSectionGalleryId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).getCvSectionGalleryItem(cvId, cvSectionGalleryId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public getCvSectionLink(cvId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).getCvSectionLink(cvId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionLinkId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public getCvSectionLinkItem(cvId: number, cvSectionLinkId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).getCvSectionLinkItem(cvId, cvSectionLinkId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public getCvSectionProfile(id: number, options?: any) {
        return ProffApiFp(this.configuration).getCvSectionProfile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public getCvSectionSkill(cvId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).getCvSectionSkill(cvId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionSkillId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public getCvSectionSkillItem(cvId: number, cvSectionSkillId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).getCvSectionSkillItem(cvId, cvSectionSkillId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public getCvSectionText(cvId: number, id: number, options?: any) {
        return ProffApiFp(this.configuration).getCvSectionText(cvId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public listCoverLetters(options?: any) {
        return ProffApiFp(this.configuration).listCoverLetters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public listCvCvSections(id: number, options?: any) {
        return ProffApiFp(this.configuration).listCvCvSections(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public listCvDataTemplates(options?: any) {
        return ProffApiFp(this.configuration).listCvDataTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public listCvDesignTemplateSamples(options?: any) {
        return ProffApiFp(this.configuration).listCvDesignTemplateSamples(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public listCvDesignTemplates(options?: any) {
        return ProffApiFp(this.configuration).listCvDesignTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public listCvExamples(options?: any) {
        return ProffApiFp(this.configuration).listCvExamples(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public listCvSamples(options?: any) {
        return ProffApiFp(this.configuration).listCvSamples(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public listCvs(options?: any) {
        return ProffApiFp(this.configuration).listCvs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateCoverLetterRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCoverLetter(id: number, body: UpdateCoverLetterRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCoverLetter(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateCvRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCv(id: number, body: UpdateCvRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCv(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {UpdateCvCvSectionsRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvCvSections(cvId: number, id: number, body: UpdateCvCvSectionsRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvCvSections(cvId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {UpdateCvPageBreaksRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvPageBreaks(cvId: number, body: UpdateCvPageBreaksRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvPageBreaks(cvId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {UpdateCvSectionDateRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionDate(cvId: number, id: number, body: UpdateCvSectionDateRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionDate(cvId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionDateId 
     * @param {number} id 
     * @param {UpdateCvSectionDateItemRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionDateItem(cvId: number, cvSectionDateId: number, id: number, body: UpdateCvSectionDateItemRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionDateItem(cvId, cvSectionDateId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionDateId 
     * @param {number} id 
     * @param {UpdateCvSectionDateItemOrderRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionDateItemOrder(cvId: number, cvSectionDateId: number, id: number, body: UpdateCvSectionDateItemOrderRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionDateItemOrder(cvId, cvSectionDateId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {UpdateCvSectionGalleryRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionGallery(cvId: number, id: number, body: UpdateCvSectionGalleryRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionGallery(cvId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionGalleryId 
     * @param {number} id 
     * @param {string} [title] 
     * @param {string} [pageBreak] 
     * @param {number} [position] 
     * @param {string} [description] 
     * @param {string} [url] 
     * @param {object} [image] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionGalleryItem(cvId: number, cvSectionGalleryId: number, id: number, title?: string, pageBreak?: string, position?: number, description?: string, url?: string, image?: object, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionGalleryItem(cvId, cvSectionGalleryId, id, title, pageBreak, position, description, url, image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionGalleryId 
     * @param {number} id 
     * @param {UpdateCvSectionGalleryItemOrderRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionGalleryItemOrder(cvId: number, cvSectionGalleryId: number, id: number, body: UpdateCvSectionGalleryItemOrderRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionGalleryItemOrder(cvId, cvSectionGalleryId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {UpdateCvSectionLinkRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionLink(cvId: number, id: number, body: UpdateCvSectionLinkRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionLink(cvId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionLinkId 
     * @param {number} id 
     * @param {UpdateCvSectionLinkItemRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionLinkItem(cvId: number, cvSectionLinkId: number, id: number, body: UpdateCvSectionLinkItemRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionLinkItem(cvId, cvSectionLinkId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionLinkId 
     * @param {number} id 
     * @param {UpdateCvSectionLinkItemOrderRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionLinkItemOrder(cvId: number, cvSectionLinkId: number, id: number, body: UpdateCvSectionLinkItemOrderRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionLinkItemOrder(cvId, cvSectionLinkId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [title] 
     * @param {string} [fullName] 
     * @param {number} [birthdayYear] 
     * @param {number} [birthdayMonth] 
     * @param {number} [birthdayDay] 
     * @param {string} [sex] 
     * @param {string} [email] 
     * @param {string} [phoneNumber] 
     * @param {string} [location] 
     * @param {string} [headline] 
     * @param {string} [websiteUrl] 
     * @param {object} [profileImage] 
     * @param {boolean} [removeProfileImage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionProfile(id: number, title?: string, fullName?: string, birthdayYear?: number, birthdayMonth?: number, birthdayDay?: number, sex?: string, email?: string, phoneNumber?: string, location?: string, headline?: string, websiteUrl?: string, profileImage?: object, removeProfileImage?: boolean, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionProfile(id, title, fullName, birthdayYear, birthdayMonth, birthdayDay, sex, email, phoneNumber, location, headline, websiteUrl, profileImage, removeProfileImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {UpdateCvSectionSkillRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionSkill(cvId: number, id: number, body: UpdateCvSectionSkillRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionSkill(cvId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionSkillId 
     * @param {number} id 
     * @param {UpdateCvSectionSkillItemRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionSkillItem(cvId: number, cvSectionSkillId: number, id: number, body: UpdateCvSectionSkillItemRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionSkillItem(cvId, cvSectionSkillId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} cvSectionSkillId 
     * @param {number} id 
     * @param {UpdateCvSectionSkillItemOrderRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionSkillItemOrder(cvId: number, cvSectionSkillId: number, id: number, body: UpdateCvSectionSkillItemOrderRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionSkillItemOrder(cvId, cvSectionSkillId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {UpdateCvSectionTextRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffApi
     */
    public updateCvSectionText(cvId: number, id: number, body: UpdateCvSectionTextRequest, options?: any) {
        return ProffApiFp(this.configuration).updateCvSectionText(cvId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProffAdminApi - axios parameter creator
 * @export
 */
export const ProffAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvCommentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvComment: async (cvId: number, body: CreateCvCommentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling createCvComment.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCvComment.');
            }
            const localVarPath = `/api/admin/cvs/{cv_id}/cv_comments`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvComment: async (cvId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling deleteCvComment.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCvComment.');
            }
            const localVarPath = `/api/admin/cvs/{cv_id}/cv_comments/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvComment: async (cvId: number, id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling getCvComment.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCvComment.');
            }
            const localVarPath = `/api/admin/cvs/{cv_id}/cv_comments/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvComments: async (cvId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling listCvComments.');
            }
            const localVarPath = `/api/admin/cvs/{cv_id}/cv_comments`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvCommentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvComment: async (cvId: number, id: number, body: UpdateCvCommentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvId' is not null or undefined
            if (cvId === null || cvId === undefined) {
                throw new RequiredError('cvId','Required parameter cvId was null or undefined when calling updateCvComment.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCvComment.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCvComment.');
            }
            const localVarPath = `/api/admin/cvs/{cv_id}/cv_comments/{id}`
                .replace(`{${"cv_id"}}`, encodeURIComponent(String(cvId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProffAdminApi - functional programming interface
 * @export
 */
export const ProffAdminApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvCommentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvComment(cvId: number, body: CreateCvCommentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20111>> {
            const localVarAxiosArgs = await ProffAdminApiAxiosParamCreator(configuration).createCvComment(cvId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvComment(cvId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProffAdminApiAxiosParamCreator(configuration).deleteCvComment(cvId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvComment(cvId: number, id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20111>> {
            const localVarAxiosArgs = await ProffAdminApiAxiosParamCreator(configuration).getCvComment(cvId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCvComments(cvId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20011>> {
            const localVarAxiosArgs = await ProffAdminApiAxiosParamCreator(configuration).listCvComments(cvId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvCommentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvComment(cvId: number, id: number, body: UpdateCvCommentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20111>> {
            const localVarAxiosArgs = await ProffAdminApiAxiosParamCreator(configuration).updateCvComment(cvId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProffAdminApi - factory interface
 * @export
 */
export const ProffAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} cvId 
         * @param {CreateCvCommentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvComment(cvId: number, body: CreateCvCommentRequest, options?: any): AxiosPromise<InlineResponse20111> {
            return ProffAdminApiFp(configuration).createCvComment(cvId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvComment(cvId: number, id: number, options?: any): AxiosPromise<object> {
            return ProffAdminApiFp(configuration).deleteCvComment(cvId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvComment(cvId: number, id: number, options?: any): AxiosPromise<InlineResponse20111> {
            return ProffAdminApiFp(configuration).getCvComment(cvId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvComments(cvId: number, options?: any): AxiosPromise<InlineResponse20011> {
            return ProffAdminApiFp(configuration).listCvComments(cvId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cvId 
         * @param {number} id 
         * @param {UpdateCvCommentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvComment(cvId: number, id: number, body: UpdateCvCommentRequest, options?: any): AxiosPromise<InlineResponse20111> {
            return ProffAdminApiFp(configuration).updateCvComment(cvId, id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProffAdminApi - object-oriented interface
 * @export
 * @class ProffAdminApi
 * @extends {BaseAPI}
 */
export class ProffAdminApi extends BaseAPI {
    /**
     * 
     * @param {number} cvId 
     * @param {CreateCvCommentRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffAdminApi
     */
    public createCvComment(cvId: number, body: CreateCvCommentRequest, options?: any) {
        return ProffAdminApiFp(this.configuration).createCvComment(cvId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffAdminApi
     */
    public deleteCvComment(cvId: number, id: number, options?: any) {
        return ProffAdminApiFp(this.configuration).deleteCvComment(cvId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffAdminApi
     */
    public getCvComment(cvId: number, id: number, options?: any) {
        return ProffAdminApiFp(this.configuration).getCvComment(cvId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffAdminApi
     */
    public listCvComments(cvId: number, options?: any) {
        return ProffAdminApiFp(this.configuration).listCvComments(cvId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cvId 
     * @param {number} id 
     * @param {UpdateCvCommentRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProffAdminApi
     */
    public updateCvComment(cvId: number, id: number, body: UpdateCvCommentRequest, options?: any) {
        return ProffAdminApiFp(this.configuration).updateCvComment(cvId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * RegisterApi - axios parameter creator
 * @export
 */
export const RegisterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [userEmail] 
         * @param {string} [userPassword] 
         * @param {string} [userPasswordConfirmation] 
         * @param {number} [userEntryPolicy] 
         * @param {string} [profileFullName] 
         * @param {string} [profileBirthdayYear] 
         * @param {string} [profileBirthdayMonth] 
         * @param {string} [profileBirthdayDay] 
         * @param {string} [profileSex] 
         * @param {string} [profilePhoneNumber] 
         * @param {string} [profileLocation] 
         * @param {string} [profileHeadline] 
         * @param {string} [profileWebsiteUrl] 
         * @param {object} [profileProfileImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountWithCv: async (userEmail?: string, userPassword?: string, userPasswordConfirmation?: string, userEntryPolicy?: number, profileFullName?: string, profileBirthdayYear?: string, profileBirthdayMonth?: string, profileBirthdayDay?: string, profileSex?: string, profilePhoneNumber?: string, profileLocation?: string, profileHeadline?: string, profileWebsiteUrl?: string, profileProfileImage?: object, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/registration.json`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (userEmail !== undefined) { 
                localVarFormParams.append('user[email]', userEmail as any);
            }
    
            if (userPassword !== undefined) { 
                localVarFormParams.append('user[password]', userPassword as any);
            }
    
            if (userPasswordConfirmation !== undefined) { 
                localVarFormParams.append('user[password_confirmation]', userPasswordConfirmation as any);
            }
    
            if (userEntryPolicy !== undefined) { 
                localVarFormParams.append('user[entry_policy]', userEntryPolicy as any);
            }
    
            if (profileFullName !== undefined) { 
                localVarFormParams.append('profile[full_name]', profileFullName as any);
            }
    
            if (profileBirthdayYear !== undefined) { 
                localVarFormParams.append('profile[birthday_year]', profileBirthdayYear as any);
            }
    
            if (profileBirthdayMonth !== undefined) { 
                localVarFormParams.append('profile[birthday_month]', profileBirthdayMonth as any);
            }
    
            if (profileBirthdayDay !== undefined) { 
                localVarFormParams.append('profile[birthday_day]', profileBirthdayDay as any);
            }
    
            if (profileSex !== undefined) { 
                localVarFormParams.append('profile[sex]', profileSex as any);
            }
    
            if (profilePhoneNumber !== undefined) { 
                localVarFormParams.append('profile[phone_number]', profilePhoneNumber as any);
            }
    
            if (profileLocation !== undefined) { 
                localVarFormParams.append('profile[location]', profileLocation as any);
            }
    
            if (profileHeadline !== undefined) { 
                localVarFormParams.append('profile[headline]', profileHeadline as any);
            }
    
            if (profileWebsiteUrl !== undefined) { 
                localVarFormParams.append('profile[website_url]', profileWebsiteUrl as any);
            }
    
            if (profileProfileImage !== undefined) { 
                localVarFormParams.append('profile[profile_image]', profileProfileImage as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegisterApi - functional programming interface
 * @export
 */
export const RegisterApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [userEmail] 
         * @param {string} [userPassword] 
         * @param {string} [userPasswordConfirmation] 
         * @param {number} [userEntryPolicy] 
         * @param {string} [profileFullName] 
         * @param {string} [profileBirthdayYear] 
         * @param {string} [profileBirthdayMonth] 
         * @param {string} [profileBirthdayDay] 
         * @param {string} [profileSex] 
         * @param {string} [profilePhoneNumber] 
         * @param {string} [profileLocation] 
         * @param {string} [profileHeadline] 
         * @param {string} [profileWebsiteUrl] 
         * @param {object} [profileProfileImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccountWithCv(userEmail?: string, userPassword?: string, userPasswordConfirmation?: string, userEntryPolicy?: number, profileFullName?: string, profileBirthdayYear?: string, profileBirthdayMonth?: string, profileBirthdayDay?: string, profileSex?: string, profilePhoneNumber?: string, profileLocation?: string, profileHeadline?: string, profileWebsiteUrl?: string, profileProfileImage?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await RegisterApiAxiosParamCreator(configuration).createAccountWithCv(userEmail, userPassword, userPasswordConfirmation, userEntryPolicy, profileFullName, profileBirthdayYear, profileBirthdayMonth, profileBirthdayDay, profileSex, profilePhoneNumber, profileLocation, profileHeadline, profileWebsiteUrl, profileProfileImage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RegisterApi - factory interface
 * @export
 */
export const RegisterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} [userEmail] 
         * @param {string} [userPassword] 
         * @param {string} [userPasswordConfirmation] 
         * @param {number} [userEntryPolicy] 
         * @param {string} [profileFullName] 
         * @param {string} [profileBirthdayYear] 
         * @param {string} [profileBirthdayMonth] 
         * @param {string} [profileBirthdayDay] 
         * @param {string} [profileSex] 
         * @param {string} [profilePhoneNumber] 
         * @param {string} [profileLocation] 
         * @param {string} [profileHeadline] 
         * @param {string} [profileWebsiteUrl] 
         * @param {object} [profileProfileImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountWithCv(userEmail?: string, userPassword?: string, userPasswordConfirmation?: string, userEntryPolicy?: number, profileFullName?: string, profileBirthdayYear?: string, profileBirthdayMonth?: string, profileBirthdayDay?: string, profileSex?: string, profilePhoneNumber?: string, profileLocation?: string, profileHeadline?: string, profileWebsiteUrl?: string, profileProfileImage?: object, options?: any): AxiosPromise<InlineResponse2008> {
            return RegisterApiFp(configuration).createAccountWithCv(userEmail, userPassword, userPasswordConfirmation, userEntryPolicy, profileFullName, profileBirthdayYear, profileBirthdayMonth, profileBirthdayDay, profileSex, profilePhoneNumber, profileLocation, profileHeadline, profileWebsiteUrl, profileProfileImage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegisterApi - object-oriented interface
 * @export
 * @class RegisterApi
 * @extends {BaseAPI}
 */
export class RegisterApi extends BaseAPI {
    /**
     * 
     * @param {string} [userEmail] 
     * @param {string} [userPassword] 
     * @param {string} [userPasswordConfirmation] 
     * @param {number} [userEntryPolicy] 
     * @param {string} [profileFullName] 
     * @param {string} [profileBirthdayYear] 
     * @param {string} [profileBirthdayMonth] 
     * @param {string} [profileBirthdayDay] 
     * @param {string} [profileSex] 
     * @param {string} [profilePhoneNumber] 
     * @param {string} [profileLocation] 
     * @param {string} [profileHeadline] 
     * @param {string} [profileWebsiteUrl] 
     * @param {object} [profileProfileImage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterApi
     */
    public createAccountWithCv(userEmail?: string, userPassword?: string, userPasswordConfirmation?: string, userEntryPolicy?: number, profileFullName?: string, profileBirthdayYear?: string, profileBirthdayMonth?: string, profileBirthdayDay?: string, profileSex?: string, profilePhoneNumber?: string, profileLocation?: string, profileHeadline?: string, profileWebsiteUrl?: string, profileProfileImage?: object, options?: any) {
        return RegisterApiFp(this.configuration).createAccountWithCv(userEmail, userPassword, userPasswordConfirmation, userEntryPolicy, profileFullName, profileBirthdayYear, profileBirthdayMonth, profileBirthdayDay, profileSex, profilePhoneNumber, profileLocation, profileHeadline, profileWebsiteUrl, profileProfileImage, options).then((request) => request(this.axios, this.basePath));
    }

}


